export default __webpack_public_path__ + "static/media/img-legal-2-en.7b8607e1.png";